import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { addLocale } from 'primereact/api';
import { saveAs } from 'file-saver';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import useParamsHeadCount from '../../helpers/useParamsHeadCount';
import { LabelField } from './SalaryChange.styles';
import dateFormat from '../../services/DateFormat.service';
import '../../DataTableDemo.css';
import { useHistory } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';
import "../../utils/tooltip.css"
import Video from '../Video/Video';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import { Skeleton } from 'primereact/skeleton';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './SalaryChange.css'
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Employes
Description : Pagina de Appointment para el CRUD de los empleados del aplicativo remunerlite.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina - Pagina de Empleados
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function SalaryChange() {

  // declarar constantes
  const [idContrato, setIdContrato] = useState("");
  const [salario, setSalario] = useState("");
  const [fechaInicioSalario, setFechaInicioSalario] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [nombre, setNombre] = useState("")
  const [headCountParams] = useParamsHeadCount();
  const [headCount, setHeadCount] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false)
  const [loading3, setLoading3] = useState(false)
  const [loading4, setLoading4] = useState(false)
  const [loading5, setLoading5] = useState(false)
  const [consultado, setConsultado] = useState(false);
  const [consultado2, setConsultado2] = useState(false);
  const [isOpenHC, setIsOpenHC] = React.useState(false);
  const [isOpenS, setIsOpenS] = React.useState(false);
  const [isOpenE, setIsOpenE] = React.useState(false);
  const [isOpenSalary, setIsOpenSalary] = React.useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = React.useState(false);
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const headers = { authorization: localStorage.getItem('token') }
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const [loadPage, setLoadPage] = useState(false)

  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  const [isOpenCargue, setIsOpenCargue] = React.useState(false);

  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);

  let history = useHistory();

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  // funcion para obtener los empleados
  useEffect(() => {
    localStorage.removeItem('number_id')
    localStorage.removeItem('name')
    setTabla()
  }, []);

  useEffect(() => {
    /*Se inicializan las propiedades del reporte head count*/
    const HCTemplate = async () => {
      let plantilla3 = []
      headCountParams.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla3.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla3.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setHeadCount(plantilla3)
    }
    HCTemplate()
  }, [headCountParams]);

  async function setTabla() {
    let contenidoTabla = []
    // await apis.getBusiness(headers).then(res => {
    //   localStorage.setItem('client', res.data.COMPANY[0]["CLIENT"]);
    // })
    await apis.getSalaries(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('token'), headers).then(res => {
      let data = res.data.CONTRACTS;
      data.forEach(element => {
        let job = element["JOB_ID"].split("|")
        let fechaInicio = element.START_DATE
        let fechaFin = element.END_DATE
        let fechaInicioSalario = tableDate(element.START_DATE_SALARY)
        contenidoTabla.push({
          CONTRACT_ID: element.CONTRACT_ID, NAME: element.NAME, IMAGE: element.IMAGES,
          JOB_ID: job[0], JOB: job[1], NUMBER_ID: element.NUMBER_ID, START_DATE: fechaInicio,
          END_DATE: fechaFin, START_DATE_SALARY: fechaInicioSalario, AMOUNT: element.AMOUNT
        })
      })
      setProducts(contenidoTabla)
      setLoadPage(true)
    })
  }

  async function putSalary() {
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _contrato = idContrato;
    const _salario = salario
    const _fechaInicioSalario = dateFormat(fechaInicioSalario);
    const _fechaInicio = fechaInicio

    const newSalary = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CONTRACT_ID: _contrato,
      AMOUNT: _salario,
      START_DATE_SALARY: _fechaInicioSalario,
      START_DATE: _fechaInicio,
      END_DATE: ""
    }

    try {
      await apis.putContractSalary(newSalary, headers).then(res => {
        setLoading5(false)
        hideModalConfirm()
        setTabla()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Salario actualizado correctamente" });
      })
    }
    catch (err) {
      setLoading5(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  //función para enviar a la pagina CreatePerson agregando o editando elementos number_id,contract_id del local storage
  function editPerson(person) {
    localStorage.setItem('number_id', person.NUMBER_ID);
    localStorage.setItem('contract_id', person.CONTRACT_ID);
    localStorage.setItem('image', person.IMAGE)
    localStorage.setItem('name', person.NAME)
    history.push("/CreatePerson")
    // window.location.href = "./CreatePerson"
  }

  //Función para enviar a la pagina CreatePerson y eliminar elementos number_id,contract_id del local storage
  function createPerson() {
    localStorage.removeItem('number_id');
    localStorage.removeItem('contract_id');
    localStorage.removeItem('image')
    history.push("/CreatePerson")
    // window.location.href = "./CreatePerson"
  }


  //Función para redirecionar a la pagina Social_benefits
  function liquidar() {
    history.push("/Novelties")
  }

  const showModalHC = () => {
    setIsOpenHC(true);
  };

  const hideModalHC = () => {
    setIsOpenHC(false);
  };

  const showModalS = () => {
    setIsOpenS(true);
  };

  const hideModalS = () => {
    setIsOpenS(false);
  };

  const showModalE = () => {
    setIsOpenE(true);
  };

  const hideModalE = () => {
    setIsOpenE(false);
  };

  const showModalSalary = () => {
    setIsOpenSalary(true);
  };

  const hideModalSalary = () => {
    setIdContrato("")
    setSalario("")
    setFechaInicioSalario("")
    setNombre("")
    setIsOpenSalary(false);
  };

  const showModalConfirm = () => {
    setIsOpenConfirm(true);
  };

  const hideModalConfirm = () => {
    setIdContrato("")
    setSalario("")
    setFechaInicioSalario("")
    setNombre("")
    setIsOpenConfirm(false);
    setIsOpenSalary(false);
    setFechaInicio("")
  };

  const showModalCargue = () => {
    setIsOpenCargue(true);
  };

  const hideModalCargue = () => {
    setIsOpenCargue(false);
  };


  const footerHC = (
    <div>
      <Button label="Generar" loading={loading} onClick={() => { setLoading(true); postHeadCountReport() }} />
    </div>
  );

  const headerHC = (
    <div>
      <h3>Parámetros reporte head count</h3>
    </div>
  )

  function handleChangeHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeDateHC(e, d, index) {
    let date = dateFormat(e.value)
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeTextHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }
  async function postHeadCountReport() {
    /*Función encargada de cargar la informacion del reporte head count*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    headCount.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    headCount.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.postReportHeadCount(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, "reporteHeadCount")
        setLoading(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte head count generado existosamente" });
        hideModalHC();
      })
    }
    catch (err) {
      setLoading(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadSalaries",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.uploadSalaries(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading6(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading6(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.uploadSalaries(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importCargue(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadSalaries",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading6(false); setLoading7(false); hideModalCargue() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading6} onClick={() => { setLoading6(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar cambios de salario</h3>
    </div>
  )

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Cargue" icon="pi pi-upload" className="p-button-success mr-2 p-button-sm"
          onClick={() => showModalCargue()} />
      </React.Fragment>
    )
  }

  //Boton liquidar Nómina en la parte derecha de la tabla
  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Liquidar Nómina" icon="pi pi-building" className="p-button mr-2 p-button-sm " onClick={() => liquidar()} />
        <Button label="Head count" icon="pi pi-book" className="p-button mr-2 p-button-sm " tooltip='Generar reporte head count'
          tooltipOptions={{ position: 'top' }} onClick={showModalHC} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => { setNombre(rowData.NAME); setIdContrato(rowData.CONTRACT_ID); setFechaInicio(rowData.START_DATE); showModalSalary() }} />
  }

  const photoBodyTemplate = (rowData) => {
    const photo = rowData.IMAGE;
    return (
      <React.Fragment>
        <img alt={""} src={photo} width={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
      </React.Fragment>
    );
  }

  const iniDateTemplate = (rowData) => {
    const date = timeToDate(rowData.START_DATE);
    return date
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  const salaryDateTemplate = (rowData) => {
    const date = timeToDate(rowData.START_DATE_SALARY);
    return date
  }

  const formatCurrency = (value) => {
    let currency = parseInt(value)
    return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  }

  const salaryTemplate = (rowData) => {
    if (rowData.AMOUNT) {
      return formatCurrency(parseInt(rowData.AMOUNT));
    } else {
      return "";
    }
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];


  const salaryHeader = (
    <div>
      <h3>Modificar salario</h3>
    </div>
  );

  const salaryFooter = (
    <div>
      <Button onClick={() => hideModalSalary()} label='Cancelar' />
      <Button onClick={() => showModalConfirm()} disabled={!salario && !fechaInicioSalario} label='Guardar' />
    </div>
  );

  const confirmHeader = (
    <div>
      <h3>Los cambios realizados serán aplicados al empleado, ¿está seguro?</h3>
    </div>
  );

  const confirmFooter = (
    <div>
      <Button onClick={() => setIsOpenConfirm(false)} label='Cancelar' />
      <Button onClick={() => { setLoading5(true); putSalary() }} label='Si' loading={loading5} />
    </div>
  );


  // Return que entrega la pantalla
  return (
    <div className='mt-2'>
      <Tooltip target=".info" className='indigo-tooltip ml-1' />
      <Dialog header={salaryHeader} footer={salaryFooter} visible={isOpenSalary} position="top" style={{ width: "24rem" }}
        draggable={false} resizable={false} modal onHide={hideModalSalary} closable={false}>
        <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
        <div>
          <Tooltip target=".info" className='indigo-tooltip ml-1' />
          <LabelField htmlFor="label">Contrato</LabelField>
          <InputText placeholder={idContrato} disabled style={{ width: '100%' }} />
          <LabelField htmlFor="label">Nombre</LabelField>
          <InputText placeholder={nombre} disabled style={{ width: '100%' }} />
          <LabelField htmlFor="label">Salario *</LabelField>
          <InputNumber value={salario} style={{ width: '100%' }}
            onValueChange={(e) => { setSalario(e.value) }}
            mode="currency" currency="COP" locale="es-CO" />
          <LabelField htmlFor="label">Fecha inicio *</LabelField>
          <Calendar id="navigators" value={fechaInicioSalario}
            onChange={(e) => { setFechaInicioSalario(e.value) }} style={{ width: '100%' }}
            locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioSalario}
            yearRange="1900:2060" />
        </div>
      </Dialog>

      <Dialog header={confirmHeader} footer={confirmFooter} visible={isOpenConfirm} position="top" style={{ width: "28rem" }}
        draggable={false} resizable={false} modal onHide={hideModalConfirm} closable={false} />

      < Dialog header={header} footer={footer} visible={isOpenCargue}
        position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue} >
        <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
        <br />
        <span>2. Diligencie la hoja UploadSalaries, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
        <br />
        <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
      </Dialog >

      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} style={{ zIndex: 1001 }} />

        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Cambio de salarios</span>
          {/* <Video header="Instructivo creación empleado" url={localStorage.getItem('EMPLOYES_VIDEO')} /> */}
        </div>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} />
            <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="CONTRACT_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'JOB', 'CONTRACT_TYPE', 'STATUS', 'START_DATE', 'END_DATE', 'RETIREMENT_DATE']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="IMAGE" header="Foto" body={photoBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} sortable></Column>
              <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="JOB" header="Cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
              <Column field="START_DATE" header="Fecha ingreso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha ingreso" sortable></Column>
              {/* <Column field="END_DATE" body={endDateTemplate} header="Fecha inicio salario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio salario" sortable></Column> */}
              <Column field="CAUSE_RETIREMENT" body={salaryTemplate} header="Salario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
              <Column field="START_DATE_SALARY" body={salaryDateTemplate} header="Fecha inicio salario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por salario" sortable></Column>
              <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>

    </div>
  );
} 